<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      max-width="480"
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-badge color="red" overlap>
            <span v-if="filtersCount" slot="badge">{{ filtersCount }}</span>
            <v-icon>tune</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <v-card>
        <v-layout wrap row pa-3>
          <v-flex xs12 px-2>
            <entity-field
              v-model="localFilters.entityId"
              :label="$tc('models.entity')"
            />
          </v-flex>
          <v-flex xs12 px-2>
            <team-field
              v-model="localFilters.teamId"
              :label="$tc('models.team')"
              :entity-id="localFilters.entityId"
            />
          </v-flex>
          <v-divider />
          <v-flex xs12 px-2>
            <v-autocomplete
              v-model="localFilters.typeRole"
              :items="roleSelectList"
              multiple
              item-value="type"
              chips
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.role', 2) })
              "
            >
              <template #selection="data">
                <v-chip color="primary" dark small>
                  {{ data.item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn color="primary" flat @click="search">
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import EntityField from '@/components/widgets/Input/EntityField'
import TeamField from '@/components/widgets/Input/TeamField'
export default {
  name: 'PendingUsersFilters',
  components: { TeamField, EntityField },
  data: () => ({
    menu: false,
  }),
  watch: {
    menu(val) {
      if (val && !this.roleSelectList.length) {
        this.$store.dispatch('roles/fetchSelectList', { limit: 0 })
      }
      if (!val) this.$emit('search')
    },
  },
  computed: {
    ...mapState({
      filters: (state) => state.stats.pendingUsers.filters,
    }),
    ...mapGetters({
      roleSelectList: 'roles/selectListFiltered',
    }),
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('stats/setPendingUsersFilters', value)
      },
    },
    filtersCount() {
      let count = 0
      Object.keys(this.localFilters || {}).forEach((key) => {
        if (
          key != 'match' &&
          this.localFilters[key] &&
          this.localFilters[key].length
        ) {
          count++
        }
      })
      return count
    },
  },
  methods: {
    search() {
      this.menu = false
      this.$emit('search')
    },
  },
}
</script>
